<template>
  <div class="main">
    <div class="questionnaire-section">
    <div class="wrapPortable wpQuestion">
      <h1 class="main-h1">FAISONS CONNAISSANCE</h1>
    </div>
    <div class="Container questionnaire">
      <div class="alert">
        <p class="pimage">
          <img src="../assets/logo/logo-info.png" alt="logo-info" class="logo-alert"/>
        </p>
        <p class="alert-info">
          Ces données sont demandées afin d'évaluer au mieux notre programme elles sont strictement confidentielle.
        </p>
      </div>
      <div class="sexe">
        <h3>Vous êtes ?</h3>
        <ul class="hf">
          <li class="homme">
            <button :class="[{selected: user.sexe === 'homme'}, 'rond']" @click.prevent="sexDefine(1)">
              <img src="../assets/logo/logo-homme.png" class="logo-sexe" alt="logo-homme"/>
            </button>
            <p @click.prevent="sexDefine(1)">Homme</p>
          </li>
          <li class="femme">
            <button :class="[{selected: user.sexe === 'femme'}, 'rond']" @click.prevent="sexDefine(0)">
              <img src="../assets/logo/logo-femme.png" class="logo-sexe" alt="logo-femme"/>
            </button>
            <p @click.prevent="sexDefine(0)">Femme</p>
          </li>
        </ul>
      </div>
      <div class="age">
        <h3>Âge</h3>
        <ul class="age_ul">
          <li class="'age_li'"><button :class="[{selected: user.age === '-19'}, 'rond', 'bli']" @click.prevent="ageDefine('A')"> <p>- <span class="age_nombre">19</span></p> </button></li>
          <li class="age_li"><button :class="[{selected: user.age === '20-30'}, 'rond', 'bli']" @click.prevent="ageDefine('B')"> <p>de <span class="age_nombre">20</span></p><p> à <span class="age_nombre">30</span></p></button></li>
          <li class="age_li"><button :class="[{selected: user.age === '30-40'}, 'rond', 'bli']" @click.prevent="ageDefine('C')"> <p>de <span class="age_nombre">31</span></p><p> à <span class="age_nombre">40</span></p></button></li>
          <li class="age_li"><button :class="[{selected: user.age === '40-50'}, 'rond', 'bli']" @click.prevent="ageDefine('D')"> <p>de <span class="age_nombre">41</span></p><p> à <span class="age_nombre">50</span></p></button></li>
          <li class="age_li"><button :class="[{selected: user.age === '+60'}, 'rond', 'bli']" @click.prevent="ageDefine('E')"> <p>+ <span class="age_nombre">51</span></p></button></li>
        </ul>
      </div>

      <div class="taille_poids">
        <div class="taille">
          <h3>Taille</h3>
            <div class="taille_define">
              <button class="moins" @click.prevent="lessMesure('taille')"><i class="fa fa-minus" aria-hidden="true"></i></button>
              <p class="taille_p"><input type="text" v-model="user.taille" class="input_poids_taille">cm</p>
              <button class="plus" @click.prevent="addMesure('taille')"><i class="fa fa-plus" aria-hidden="true"></i></button>
          </div>
        </div>
        <div class="poids">
          <h3>Poids</h3>
          <div class="poids_define">
            <button class="moins" @click.prevent="lessMesure('poids')"><i class="fa fa-minus" aria-hidden="true"></i></button>
            <p class="poids_p"><input type="text" v-model="user.poids" class="input_poids_taille">kg</p>
            <button class="plus" @click.prevent="addMesure('poids')"><i class="fa fa-plus" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>

      <div class="profession">
        <h3>Votre profession</h3>
        <div class="profession_define">
          <autocomplete :source="tableau_profession" :placeholder="user.metier !== null ? user.metier : 'Search'" v-model="user.metier" >  
          </autocomplete>
        </div>
      </div>

    </div>
    <div class="subTest">
      <button class="submitQuestionnaire"  v-on:click="postData()">Suivant</button>
    </div>
    </div>
  </div>
</template>


<script>
import Autocomplete from 'vuejs-auto-complete';
import { User } from "../controller/user.js";
import { hostUrl } from "../_helpers/global_var";

const axios = require('axios').default;

export default {
  name: "Questionnaire",
  data() {
    return {
      user: JSON.parse(localStorage.user)|| [],
      tableau_profession: [{
        id:'soudeur',
        name:'soudeur'
        },{
          id:'chaudronier',name:'chaudronier'
      }],
    };
  },
  components: {
    Autocomplete,
  },
  created() {
    if (typeof(localStorage.user) !== undefined){
      this.user = JSON.parse(localStorage.user);
      if (this.user.liste_Metier !== [] && this.user.liste_Metier.length > 0){
        this.tableau_profession = this.user.liste_Metier;
        //console.log(this.user.liste_Metier.length);
      }
      //console.log(this.user);
    }else{
      console.log('var not exist');
    }
    },
  methods: {
    sexDefine (sexe){
      if (sexe === 0) {
        this.user.sexe = 'femme'
        //console.log(this.user.sexe)
        
      }else{
        this.user.sexe = 'homme'     
      }
    },
    ageDefine (age){
      if (age === 'A'){
        this.user.age = '-19'
        //console.log(this.user.age + ' ans')
      }else if (age === 'B'){
        this.user.age = '20-30'
        //console.log(this.user.age + ' ans')
      }else if (age === 'C'){
        this.user.age = '30-40'
        //console.log(this.user.age + ' ans')
      }else if (age === 'D'){
        this.user.age = '40-50'
        //console.log(this.user.age + ' ans')
      }else{
        this.user.age = '+60'
        //console.log(this.user.age + ' ans')
      }
    },
    addMesure (att){
      if (att === 'poids'){
        this.user.poids++
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille++
        //console.log(this.user.taille + ' cm')
      }
    },
    lessMesure (att){
      if (att === 'poids'){
        this.user.poids--
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille--
        //console.log(this.user.taille + ' cm')
      }     
    },
    postData(){  
      console.log(JSON.stringify(this.user)); 
      axios

      .post(hostUrl+'/salarie/edit', JSON.stringify(this.user))
      .then(response => this.userOk(response, this.user.password))
      .catch(error => console.log(error));
    },
    userOk (response, pass){
          //console.log(response.data);
          let koko = new User (response.data);
          koko.password = pass;
          localStorage.removeItem('user');
          localStorage.user = JSON.stringify(koko);
          console.log(koko.douleurs);
          if (koko.douleurs == null || koko.douleurs == [] || Object.size(koko.douleurs) == 0){
            return this.$router.push({ name: 'Indicateur' });
          }else{
            return this.$router.push({ name: 'Accueil' });
          }  
      },
    beforeRouteLeave: (to, from, next) => {
    try {
      var koko = JSON.parse(localStorage.user)
    } catch (error) {
      var koko = new User();
    }
    if (typeof(localStorage.user) !== 'undefined' && koko.poids !== null && koko.taille !== null){
      next('Indicateur');
    }else {
      alert('Il est impératif qui vous ayez réalisé ce questionnaire, vous pourrez accéder aux autres pages une fois qu\'il sera validé');
      next(false);
    }
  },
  },
  computed: {
    ideal (){
      return this.user.poids = this.user.taille -100 - ((this.user.taille - 150)/4);
    }
  }
};
</script>
<style>
@media screen and (min-width: 1300px){
  .questionnaire{
    height: 60vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Questionnaire.vue